export default "__VITE_ASSET__d177bc51__"